import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import { useClassName, useWindowSize } from 'common/hooks';
import SliderControls from './SliderControls';
import FeaturedEventCard from './FeaturedEventCard';
import { usePagination } from '../../Home/Components/usePagination';

import './styles/featured-events.less';

const FeaturedEvents = ({ blueprint, events, inDetail }) => {
  const classNames = useClassName('FeaturedEvents');
  const { isMobile } = useWindowSize();

  const [swiperRef, setSwiperRef] = useState(null);
  const [hasMultipleSlides, setHasMultipleSlides] = useState(false);

  const slidePrev = () => swiperRef?.slidePrev();
  const slideNext = () => swiperRef?.slideNext();

  const handleSwiperInit = (swiper) => {
    setSwiperRef(swiper);

    const bullets = swiper.pagination.bullets;
    setHasMultipleSlides(bullets.length > 1);
  };

  const pagination = usePagination({
    horizontalClass: classNames('custom-pagination'),
    useCustomElement: true,
  });

  return (
    <div
      className={classNames('container')}
      style={{
        backgroundImage: `linear-gradient(180deg, ${
          blueprint.featuredBackgroundColors[0] || '#000'
        } 1.86%, ${blueprint.featuredBackgroundColors[1] || '#2348F2'} 100%)`,
        paddingBottom: inDetail ? '60px' : '',
      }}>
      <div className={classNames('text-container')}>
        <div className={classNames('text')}>
          {inDetail ? (
            <div className={classNames('in-detail')}>Explore more events</div>
          ) : (
            <>
              <div className={classNames('title')}>
                {blueprint.featuredSectionTitle}
              </div>
              <div className={classNames('description')}>
                {blueprint.featuredSectionDescription}
              </div>
            </>
          )}
        </div>
      </div>
      <Swiper
        {...pagination}
        modules={[Pagination]}
        centeredSlides={isMobile ? true : false}
        spaceBetween={20}
        slidesPerView="auto"
        speed={500}
        onSwiper={handleSwiperInit}
        preventClicksPropagation={true}
        className={classNames('carousel')}>
        {events.map((event) => (
          <SwiperSlide key={event._id} className={classNames('slide')}>
            <FeaturedEventCard event={event} />
          </SwiperSlide>
        ))}
      </Swiper>

      <div className={classNames('pagination-and-arrows')}>
        {hasMultipleSlides && (
          <SliderControls direction="prev" onClick={slidePrev} />
        )}
        <div className={classNames('custom-pagination')} />
        {hasMultipleSlides && (
          <SliderControls direction="next" onClick={slideNext} />
        )}
      </div>
    </div>
  );
};

FeaturedEvents.propTypes = {
  blueprint: PropTypes.object,
  events: PropTypes.array,
  inDetail: PropTypes.bool,
};

FeaturedEvents.defaultProps = {
  inDetail: false,
};

export default FeaturedEvents;
